(() => {
  'use strict';
  if (window.YoLinkUrlContext) return;
  const allowed = /^(?:preview_theme_id|preview_script_id|pb|utm_[a-z0-9_]+|gclid|fbclid|msclkid|ttclid|wbraid|gbraid|irclickid|irgwc|rfsn|ref|referral|referral_id|aff|aff_id|affiliate|affiliate_id|shpxid)$/i;
  const entries = source => [...source.searchParams].filter(([key]) => allowed.test(key));
  // Navigation only: pagination has its own stricter drift/field validation.
  const preserve = (destination, source) => {
    if (destination.origin !== source.origin) return destination;
    const existing = new Set(destination.searchParams.keys());
    for (const [key, value] of entries(source)) {
      if (!existing.has(key)) destination.searchParams.append(key, value);
    }
    return destination;
  };
  window.YoLinkUrlContext = { entries, preserve };
})();
